import './Footer.css';

function Footer({ menuCollapse }) {
    const currentYearUTC = new Date().getUTCFullYear();
    return (
        <footer className={`app-footer ${menuCollapse ? "collapse-main-warpper" : "main-wrapper"}`}>
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className='col-xl-4 col-lg-3 col-sm-1'></div>
                    <div className='col-xl-4 col-lg-5 col-sm-7 primary-footer-font d-flex align-items-center'>Copyright © Lateetud {currentYearUTC} | All Rights Reserved</div>
                    <div className='col-4 primary-footer-font d-flex align-items-center justify-content-end'>
                        Powered By
                        <img className="ms-2" src="/assets/logos/FooterLogo.png" width="125" alt="Lateetud" />
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer